"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrsaColorPickerInputButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _createFocusRingStyles = require("../../../../util/createFocusRingStyles");
var _withFocusClassName = require("../../../../util/withFocusClassName");
var _button = require("../../../button");
function createFocusRing() {
  const styles = (0, _createFocusRingStyles.createFocusRingStyles)({
    theme: "ursa-light",
    componentRadius: "4px",
    gap: 1,
    componentBorderWidth: 1,
    position: "absolute"
  });
  return styles;
}
const UrsaColorPickerInputButton = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)(_button.Button)`
    width: auto;
    position: absolute;
    top: 6px;
    right: 6px;
    ${createFocusRing}
`);
exports.UrsaColorPickerInputButton = UrsaColorPickerInputButton;
//# sourceMappingURL=UrsaColorPickerInputButton.js.map